import api from '@/apis'
import * as TYPES from './mutationTypes'

export default {
  //ca列表
  getCaLists({ commit }, params) {
    return api.camanage
      .getCaList(params)
      .then(response => response.data)
      .then(result => {
        commit(TYPES.GET_CA_LIST, {
          result,
          params
        })
        return result
      })
      .catch(error => Promise.reject(error))
  },

  // 删除ca服务
  deleteCa({ commit }, params) {
    return api.camanage.deleteCa(params)
  }
}
